import { noop } from 'lodash';

import type { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

// Default empty implementation of NewRelicBrowserAgent that will be assigned with real Agent on the client side
export const NewRelicBrowser = {
  agent: {
    noticeError: noop,
  } as unknown as BrowserAgent,
};
